import type { StopTimeData, Trip } from '@/@types/gtfs-ressource';
import type { TripUpdate } from '@/@types/trip-updates';
import { tripUpdateOnServiceDate } from '@/libs/journey/realtime';

/**
 * The trip and the trip update of the occurrence a stop time belongs to. After midnight
 * a stop time can come from the day before, whose trip_id today's trips and updates share
 * (#293, D4): both are read on its service_date, never on today's.
 */
export function tripOccurrence(
  stopTime: Pick<StopTimeData, 'trip_id' | 'service_date'>,
  getTripsOfDay: (dateGtfs: string) => { readonly [tripId: string]: Trip },
  tripUpdates: ReadonlyArray<TripUpdate>,
): { trip: Trip | undefined; tripUpdate: TripUpdate | undefined } {
  return {
    trip: getTripsOfDay(stopTime.service_date)[stopTime.trip_id],
    // Matched on the date too: an update of each day for the same trip_id can be loaded at once.
    tripUpdate: tripUpdates.find(
      tripUpdate =>
        tripUpdate.trip_id === stopTime.trip_id && tripUpdateOnServiceDate(tripUpdate, stopTime.service_date),
    ),
  };
}
